import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import {Toolbar} from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import React, {useState} from "react";
import PropTypes from "prop-types";
import {useCustomToolbarStyles} from "./CustomToolbarStyles";
import {colors} from "../../../shared/colors";
import UserInfo from "./user-info/UserInfo";
import CustomersDialog from "./customers-dialog/CustomersDialog";


const CustomToolbar = (props) => {
    const classes = useCustomToolbarStyles();
    const [openCompaniesDialog, setOpenCompaniesDialog] = useState(false)
    return (
        <AppBar position="fixed" style={{backgroundColor: colors.primary.contrastText}} className={classes.appBar}>
            <Toolbar className={classes.toolbar}>
                <IconButton
                    aria-label="open drawer"
                    edge="start"
                    onClick={props.handleSidebarToggle}
                    className={classes.menuButton}
                >
                    <MenuIcon/>
                </IconButton>
                <Typography variant="h6" noWrap className={classes.toolbarText}>
                    Medie e grandi imprese - Mobile
                </Typography>
                <UserInfo handleOpenCompaniesDialog={() => setOpenCompaniesDialog(true)}
                          handleCloseDialog={() => setOpenCompaniesDialog(false)}/>
            </Toolbar>
            {openCompaniesDialog ? (
                <CustomersDialog
                    open={openCompaniesDialog}
                    handleDialogClose={() => setOpenCompaniesDialog(false)}
                    handleDialogCloseButton={() => setOpenCompaniesDialog(false)}
                />
            ) : null}
        </AppBar>
    )
}

CustomToolbar.propTypes = {
    handleSidebarToggle: PropTypes.func.isRequired
}

export default CustomToolbar;
